"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Done_1 = __importDefault(require("@material-ui/icons/Done"));
const query_1 = require("@reduxjs/toolkit/query");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_cookie_1 = require("react-cookie");
const react_gtm_module_1 = __importDefault(require("react-gtm-module"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const ab_tests_api_1 = require("ab-tests-api");
const config_1 = require("config");
const consumer_applications_v1_api_1 = require("consumer-applications-v1-api");
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const context_1 = require("context");
const hooks_1 = require("hooks");
const utils_1 = require("utils");
const actions_1 = require("../actions");
const components_1 = require("../components");
const PreQualificationForm_1 = __importDefault(require("../forms/PreQualificationForm"));
const reducer_1 = require("../reducer");
const PreQualificationSubprime_1 = __importDefault(require("./PreQualificationSubprime"));
function PreQualification({ payload, onStepComplete, applicationEnvironment, }) {
    const getToken = () => {
        const query = (0, utils_1.parseQuery)(location.search);
        const token = query[config_1.QUERY_KEY.TOKEN];
        return token;
    };
    //CUSTOM HOOKS
    const [getBlackboxData] = (0, hooks_1.useIovation)();
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const [, , removeCookie] = (0, react_cookie_1.useCookies)(['proveAb', 'proveStoreAb']);
    const dispatch = (0, react_redux_1.useDispatch)();
    //COMPONENT STATE
    const [preQualDeclineModalShow, setPreQualDeclineModalShow] = (0, react_1.useState)(false);
    const [declinedPayload, setDeclinedPayload] = (0, react_1.useState)(null);
    const [waterFalling, setWaterfalling] = (0, react_1.useState)(false);
    const [terms, setTerms] = (0, react_1.useState)(null);
    const tokenRef = (0, react_1.useRef)(getToken());
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    //REDUX STATE
    const personalInfo = (0, react_redux_1.useSelector)(reducer_1.selectors.personalInfo);
    const practice = (0, react_redux_1.useSelector)(reducer_1.selectors.practice);
    const prequalification = (0, react_redux_1.useSelector)(reducer_1.selectors.prequalification);
    const activeOfferId = (0, react_redux_1.useSelector)(reducer_1.selectors.activeOfferId);
    const offerScreen = (0, react_redux_1.useSelector)(reducer_1.selectors.offerScreen);
    const { firstName, lastName } = personalInfo;
    const { offers, applicationServiceProviderPriority } = prequalification;
    const activeOffer = activeOfferId
        ? offers.find((offer) => offer.offerId === activeOfferId)
        : (0, lodash_1.first)(offers);
    const lenderName = offers && activeOffer && activeOffer.serviceProviderName;
    const lenderProductType = offers && activeOffer && activeOffer.lenderProductType;
    const { amount: prequalifiedCreditLimit } = activeOffer
        ? activeOffer
        : { amount: 0 };
    const isPrequalified = prequalification.applicationStatus === 'prequalified';
    const applyForLineOfCredit = lenderName === 'ADS' || lenderName === undefined;
    const submitButtonText = applyForLineOfCredit
        ? ' ACCEPT OFFER AND SUBMIT APPLICATION'
        : 'ACCEPT OFFER';
    //API HOOKS
    const [applyAfterPrequalificationV1] = (0, consumer_applications_v1_api_1.usePostConsumerApplicationsV1CreditApplicationsApplyAfterPrequalificationMutation)();
    const [applyAfterPrequalificationV2] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsApplyAfterPrequalificationMutation)();
    const [prequalifyWithNextLenderV1] = (0, consumer_applications_v1_api_1.usePostConsumerApplicationsV1PrequalificationsApplicationIdNextLenderMutation)();
    const [prequalifyWithNextLenderV2] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2PrequalificationsApplicationIdNextLenderMutation)();
    const { data: lenderTerms } = (0, consumer_applications_v1_api_1.useGetConsumerApplicationsV1LocationsLocationIdLenderTermsLenderNameQuery)(lenderName === 'ADS' || lenderName === undefined
        ? {
            locationId: prequalification.location.locationId,
            lenderName: 'ADS',
        }
        : query_1.skipToken);
    const [submitFullApplicationV1, {}] = (0, consumer_applications_v1_api_1.usePostConsumerApplicationsV1CreditApplicationsApplicationIdApplyMutation)();
    const [submitFullApplicationV2, {}] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsApplicationIdApplyMutation)();
    const [, { data: waterfallVariant }] = (0, ab_tests_api_1.usePostAbTestsV1ParticipantsAssignVariantTestSlugMutation)({
        fixedCacheKey: practice
            ? `waterfall-ab-${practice.adsStoreNumber}`
            : 'waterfall-ab-no-store',
    });
    const isWaterfallV2 = waterfallVariant?.variant.name === 'treatment' ? true : false;
    //HANDLERS
    const getApplyAfterPrequalArgs = (offer, authorizedBuyer) => {
        const { applicationId } = prequalification;
        const acceptedOffer = offer;
        const { offerId: acceptedOfferId, terms: acceptedOfferTerms } = acceptedOffer ? acceptedOffer : { offerId: 0, terms: [] };
        const blackboxData = getBlackboxData();
        const approvedTerms = acceptedOfferTerms
            ? (0, utils_1.approveTerms)(...acceptedOfferTerms)
            : [];
        const application = {
            applicationId,
            acceptedOfferId,
            iovationBlackBox: blackboxData.blackbox,
            prerequisiteTermsAccepted: approvedTerms,
            ...(authorizedBuyer ? authorizedBuyer : {}),
        };
        return application;
    };
    const handleSubmit = async (authorizedBuyer) => {
        const { applicationId } = prequalification;
        const blackboxData = getBlackboxData();
        if (location.state?.fullApp) {
            const application = {
                applicationId,
                iovationBlackBox: blackboxData.blackbox,
                prerequisiteTermsAccepted: terms.map(({ termContentId }) => ({
                    termContentId,
                    acceptedOn: new Date().toISOString(),
                })),
                ...authorizedBuyer,
            };
            const res = isWaterfallV2
                ? await submitFullApplicationV2({
                    applicationId,
                    postConsumerApplicationsV2CreditApplicationsApplicationIdApply: application,
                })
                : await submitFullApplicationV1({
                    applicationId,
                    postConsumerApplicationsV1CreditApplicationsApplicationIdApply: application,
                });
            if ('data' in res) {
                dispatch((0, actions_1.setApprovedApplication)(res.data));
            }
            return res;
        }
        else {
            const application = getApplyAfterPrequalArgs(activeOffer, authorizedBuyer);
            const res = isWaterfallV2
                ? await applyAfterPrequalificationV2({
                    postConsumerApplicationsV2CreditApplicationsApplyAfterPrequalification: application,
                })
                : await applyAfterPrequalificationV1({
                    postConsumerApplicationsV1CreditApplicationsApplyAfterPrequalification: application,
                });
            if ('data' in res) {
                dispatch((0, actions_1.setApprovedApplication)(res.data));
            }
            return res;
        }
    };
    const handleChoosePrimeOffer = async (offer) => {
        const application = getApplyAfterPrequalArgs(offer);
        const res = await applyAfterPrequalificationV2({
            postConsumerApplicationsV2CreditApplicationsApplyAfterPrequalification: application,
        });
        if ('data' in res) {
            dispatch((0, actions_1.setApprovedApplication)(res.data));
            handleSubmitSuccess(res);
        }
        else {
            handleDecline(applicationServiceProviderPriority);
        }
    };
    const handleDecline = (applicationServiceProviderPriority) => {
        if (applicationServiceProviderPriority &&
            applicationServiceProviderPriority.productType === 'installment') {
            history.push(config_1.PRE_QUALIFICATION_ACCEPT_DECLINED_URL);
            //declined after prequal for both
        }
        else {
            //declined after prequal for bread
            history.push(config_1.DECLINED_URL);
        }
    };
    const handleSubmitSuccess = ({ data, }) => {
        setWaterfalling(true);
        const { applicationStatus, locationServiceProviderPriorities, applicationServiceProviderPriority, applicationId, lenderRequestReferenceId, pendingDecisionDetails, lenderStatusMessage, } = data;
        dispatch((0, actions_1.setLenderReferenceId)(lenderRequestReferenceId));
        dispatch((0, actions_1.setPendingDecisionDetails)(pendingDecisionDetails));
        setDeclinedPayload({
            ...payload,
            applicationId,
        });
        if (applicationStatus === 'approved') {
            analytics?.track('ApplicationApproved', {});
            onStepComplete();
        }
        else if (applicationStatus === 'account_exists') {
            history.push(config_1.ACCOUNT_EXISTS_URL);
        }
        else if (applicationStatus === 'pending' &&
            lenderStatusMessage === config_1.BREAD_LENDER_STATUS.STEP_UP_NEEDED) {
            history.push(config_1.STEP_UP_REQUIRED_URL);
        }
        else if (applicationStatus === 'pending') {
            history.push(config_1.PRE_QUALIFICATION_INFORMATION_REQUIRED_URL);
        }
        else if (applicationStatus === 'prequalified') {
            if (offers.length > 1 &&
                offers.some((offer) => offer.offerType === 'prequalified' &&
                    config_1.PRIME_LENDERS.includes(offer.serviceProviderName))) {
                // This allows the user to select a different prime offer if they have one
                handleDecline(applicationServiceProviderPriority);
                return;
            }
        }
        else if (applicationStatus === 'declined') {
            const nextLender = locationServiceProviderPriorities.consumer.some(({ priority }) => {
                if (applicationServiceProviderPriority) {
                    return priority > applicationServiceProviderPriority.priority;
                }
                else {
                    return false;
                }
            });
            if (nextLender) {
                const blackboxData = getBlackboxData();
                if (isWaterfallV2) {
                    return prequalifyWithNextLenderV2({
                        applicationId,
                        postConsumerApplicationsV2PrequalificationsApplicationIdNextLender: {
                            iovationBlackBox: blackboxData.blackbox,
                        },
                    })
                        .then(handleNextLenderResponse)
                        .catch(handleNextLenderError);
                }
                else {
                    return prequalifyWithNextLenderV1({
                        applicationId,
                        postConsumerApplicationsV1PrequalificationsApplicationIdNextLender: {
                            iovationBlackBox: blackboxData.blackbox,
                        },
                    })
                        .then(handleNextLenderResponse)
                        .catch(handleNextLenderError);
                }
            }
            else {
                handleDecline(applicationServiceProviderPriority);
                return;
            }
        }
        else {
            throw new Error('Not Handled');
        }
        setWaterfalling(false);
    };
    const handleNextLenderResponse = (response) => {
        if ('data' in response) {
            dispatch((0, actions_1.setLenderReferenceId)(response.data.lenderRequestReferenceId));
            const offers = response.data.offers;
            dispatch((0, actions_1.setActiveOfferId)(offers ? offers[0].offerId : undefined));
            const nextStep = (0, utils_1.determinePrequalificationResponse)(response.data, 'credit');
            dispatch((0, actions_1.setPrequalification)(response.data));
            history.push(nextStep);
            setWaterfalling(false);
            return;
        }
    };
    const handleNextLenderError = (error) => {
        setWaterfalling(false);
        const nextStep = (0, utils_1.determinePrequalificationError)(error);
        if (nextStep) {
            history.push(nextStep);
            return;
        }
        const errMsg = (0, utils_1.apiErrorToErrorMessage)(error?.response?.errorCode, error?.response?.message);
        (0, utils_1.reportError)('flashError', {
            componentName: 'PreQualification',
            funcName: 'handleSubmitSuccess',
            errType: 'api',
            errURL: window.location.pathname,
            errMsg: errMsg,
        }, error);
        (0, utils_1.toastError)(errMsg);
    };
    //EFFECTS
    (0, react_1.useEffect)(() => {
        react_gtm_module_1.default.dataLayer({
            dataLayer: {
                event: 'conversion',
            },
        });
    }, []);
    (0, react_1.useEffect)(() => {
        const unblock = history.block((location, action) => {
            if (action === 'POP' && !(0, lodash_1.isNil)(tokenRef.current)) {
                // One Time Apps back button -> no action
                // Return true to allow transition, false to block
                return false;
            }
        });
        return () => {
            unblock();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (offers && activeOffer && activeOffer.terms) {
            setTerms(activeOffer.terms);
        }
        else if (applyForLineOfCredit && lenderTerms?.terms) {
            setTerms(lenderTerms.terms);
        }
    }, [prequalification, lenderTerms]);
    (0, react_1.useEffect)(() => {
        if (prequalification) {
            if (offers && activeOffer && activeOffer.serviceProviderName) {
                dispatch((0, actions_1.setLenderName)(lenderName));
            }
            else {
                dispatch((0, actions_1.setLenderName)(''));
            }
        }
        else {
            dispatch((0, actions_1.setLenderName)(''));
        }
    }, [prequalification]);
    (0, react_1.useEffect)(() => {
        removeCookie('proveAb');
        removeCookie('proveStoreAb');
        if (activeOfferId === undefined && activeOffer) {
            dispatch((0, actions_1.setActiveOfferId)(activeOffer.offerId));
        }
    }, []);
    (0, react_1.useEffect)(() => {
        dispatch((0, actions_1.setOfferScreen)('PRESENTED OFFER'));
    }, [activeOfferId]);
    (0, react_1.useEffect)(() => {
        window.scrollTo(0, 0);
        return () => {
            dispatch((0, actions_1.setActiveOfferId)(undefined));
            dispatch((0, actions_1.setOfferScreen)('PRESENTED OFFER'));
        };
    }, []);
    if ((0, lodash_1.isNil)(prequalification))
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: config_1.CREDIT_PORTAL_URL });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: lenderName !== 'Imprint' ? ((0, jsx_runtime_1.jsxs)("div", { children: [offerScreen !== 'OTHER OFFERS' &&
                    (applyForLineOfCredit ? ((0, jsx_runtime_1.jsxs)("div", { className: "pre-qualification-card", children: [isPrequalified ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { className: "first-title", children: ["Congratulations, ", firstName, " ", lastName] }), (0, jsx_runtime_1.jsx)("p", { className: "first-subtitle", children: "You're pre-qualified for the Alphaeon Credit Card" })] }, "prequalified")) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { className: "first-title", children: [' ', firstName, " ", lastName] }), (0, jsx_runtime_1.jsx)("p", { className: "first-subtitle", children: (0, jsx_runtime_1.jsx)("span", { className: "not-important", children: "We were unable to pre-qualify you, however you may still submit an application. Submitting a full application will result in a hard credit inquiry, which can negatively impact your credit score." }) })] }, "not-prequalified")), (0, jsx_runtime_1.jsxs)("div", { className: "first-card", children: [isPrequalified && ((0, jsx_runtime_1.jsxs)("div", { className: "first-card-header", children: [(0, jsx_runtime_1.jsxs)("p", { className: "first-limit", children: ["PRE-QUALIFIED CREDIT LIMIT +", ' '] }), (0, jsx_runtime_1.jsx)("p", { className: "first-price", children: (0, utils_1.formatCurrency)(prequalifiedCreditLimit, 2) }), (0, jsx_runtime_1.jsx)("div", { className: "first-detail", children: "+ The credit limit provided is based on your pre-qualification only, and upon submission of your full credit application, may be increased or decreased." })] })), (0, jsx_runtime_1.jsxs)("div", { className: "first-card-body", children: [(0, jsx_runtime_1.jsx)("p", { className: "first-card-body-header", children: "Cardmember Benefits:" }), (0, jsx_runtime_1.jsxs)("p", { className: "first-card-body-sub-header bold", children: ["Patient Financing offered by Dentists, Dermatologists,", ' ', (0, jsx_runtime_1.jsx)("br", {}), "Plastic Surgeons, and Ophthalmologists"] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", { className: "flex", children: [(0, jsx_runtime_1.jsx)("div", { className: "first-card-icon-container m-b-10", children: (0, jsx_runtime_1.jsx)(Done_1.default, { className: "first_tick" }) }), (0, jsx_runtime_1.jsx)("p", { children: "Special financing options* for any purchase over $250" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex", children: [(0, jsx_runtime_1.jsx)("div", { className: "first-card-icon-container m-b-10", children: (0, jsx_runtime_1.jsx)(Done_1.default, { className: "first_tick" }) }), (0, jsx_runtime_1.jsxs)("p", { children: ["Ability to reuse your card again and again with Dentists, ", (0, jsx_runtime_1.jsx)("br", {}), " Dermatologists, Ophthalmologists, and Plastic Surgeons nationwide at participating locations."] })] }), (0, jsx_runtime_1.jsx)("div", { className: "italic", children: (0, jsx_runtime_1.jsxs)("p", { children: ["Alphaeon Credit Card Accounts are issued by Comenity Capital Bank.", (0, jsx_runtime_1.jsx)("br", {}), "Credit card offers are subject to credit approval.", (0, jsx_runtime_1.jsx)("br", {}), "\"Minimum payments are required for each Credit Plan. Valid for single transaction only."] }) })] })] })] })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(PreQualificationSubprime_1.default, { prequalifiedLoanAmount: (0, utils_1.formatCurrency)(prequalifiedCreditLimit, 2), practice: practice, lenderName: lenderName, lenderProductType: lenderProductType }) }))), terms ? ((0, jsx_runtime_1.jsx)(PreQualificationForm_1.default, { personalInfo: personalInfo, lenderName: lenderName, onSubmit: handleSubmit, onSubmitSuccess: handleSubmitSuccess, onSubmitFail: utils_1.flashSubmitFailure, practice: practice, applicationEnvironment: applicationEnvironment, terms: terms, submitButtonText: submitButtonText, showTerms: applyForLineOfCredit, waterFalling: waterFalling, prequalification: prequalification, submitting: false, handleAcceptOffer: handleChoosePrimeOffer })) : null, preQualDeclineModalShow && ((0, jsx_runtime_1.jsx)(components_1.PrequalAcceptDeclineModal, { payload: declinedPayload, onClose: () => setPreQualDeclineModalShow(false) }))] }, "not-imprint")) : ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(components_1.ImprintPresentedOffer, { practiceName: practice.name, activeOffer: activeOffer, offers: offers, handleAcceptOffer: handleChoosePrimeOffer }) }, "imprint")) }));
}
exports.default = PreQualification;
